import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../../components/LoaderScreen";
import Swal from "sweetalert2";
import request from "../../../../Helpers/API";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { CargarConvenioModal } from "../Modal/CargarConvenioModal";
import { DescargarConvenioModal } from "../Modal/DescargarConvenioModal";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import FiltroConveniosRealizados from "../Components/FiltroConveniosRealizados";
import { useBox } from "../../ReporteCobranza/Helper/useBox";
import { GetKey } from "../../ReporteCobranza/Actions/GetContainer";
import AgregarObjecionPagoModal from "../Modal/AgregarObjecionPagoModal";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import EditIcon from '@mui/icons-material/Edit';
import EditarObjecionPagoModal from "../Modal/EditarObjecionPagoModal";

export const ObjecionesPagoScreen = () => {
    const history = useHistory();
    const { state } = useLocation();
    const [objeciones, setObjeciones] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [openModalEditar, setOpenModalEditar] = useState(false);
    const [selectedID, setSelectedID] = useState();

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const handleOpenModal = () => {
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleOpenModalEditar = (id) => {
        setSelectedID(id);
        setOpenModalEditar(true);
    };

    const handleCloseModalEditar = () => {
        setSelectedID(null)
        setOpenModalEditar(false);
    };

    useEffect(() => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(
                `ObjecionesPago/MostrarObjeciones`
            )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setObjeciones(result);
                return;
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                return;
            });
        setLoader({ ...loader, mostrar: false });
    }, [openModal, openModalEditar]);
    // console.log(objeciones)


    return (
        <PlantillaScreen
            titulo={`OBJECIONES DE PAGO`}
            className={"objeciones-pago-main-screen"}
            className_main={1}
        >
            <div className="objeciones-pago-actions">
                <div
                    className="objeciones-pago-actions-regresar"
                    onClick={() => history.goBack()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <div className="buttons">
                    <button className="objeciones-pago-header-agregar-objecion"
                        onClick={() => handleOpenModal()}
                    >
                        <AddCircleOutlineIcon /> Agregar
                    </button>
                </div>
            </div>
            <div className="objeciones-pago">
                <LoaderScreen loader={loader} />
                <div className="objeciones-pago-header">
                    <div className="objeciones-pago-header-title">
                        <FormatListNumberedIcon /> Listado de Objeciones Registradas
                    </div>
                </div>
                <div className="objeciones-pago-container scroll-4">
                    <table>
                        <thead>
                            <tr>
                                <th>Descripción</th>
                                <th>
                                    <div>Estatus</div>
                                </th>

                                <th>
                                    <div>Editar</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {objeciones.map((ob) => (
                                <tr key={ob.id_Objecion}>
                                    <td className="ta-descripcion">{ob.descripcion}</td>
                                    <td className="ta-estatus">
                                        {ob.estatus === 0 ? (
                                            <RemoveCircleIcon sx={{ color: "#7b7b7b" }} />
                                        ) : (
                                            <CheckCircleIcon sx={{ color: "#5aa05b" }} />
                                        )}
                                    </td>

                                    <td className="ta-editar">
                                        <div className="objeciones-pago-acciones-listado">
                                            <div
                                                className="boton-editar-objeciones-pago"
                                                onClick={() => handleOpenModalEditar(ob.id_Objecion)}
                                            >
                                                <EditIcon /> Editar
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <AgregarObjecionPagoModal
                    open={openModal}
                    onClose={handleCloseModal}
                //   folio={folio}
                />
                <EditarObjecionPagoModal
                    open={openModalEditar}
                    onClose={handleCloseModalEditar}
                    id={selectedID}
                />
            </div>
        </PlantillaScreen>
    );
};
